/// <reference path="../../app.definition.ts" />

import angular from "angular";
import { Util } from "@common/util";
import { Subject } from "@common/model/subject";
import { JavaApiAdapterService } from "@common/apiadapter/javaapi.service";


// define & export class
export class PopUpService {

    confirmationMessage: string;
    infoMessage: string;
    yesOption;
    noOption;
    removeCross;
    error: any;
    type: string;
    data: any;
    showOptions: boolean;
    currentOpenModal;
    openInformationModal: (confirmationMessage, error?, type?, infoMessage?, showUpper?, mdlClass?) => any;
    OpenInvitePopup: (subject, user, popupMessage, title?: string, inviteCancelInfo?: string, isQuickPopUp?: boolean) => any;
    openConfirmationModal: Function;
    OpenTransferOwnershipModal: Function;
    openCoveredEntity: Function;
    openSignupJoinTeam: Function;
    openDocumentPopUp: Function;
    openTeamRolePopUp: Function;
    openPrivacyPopUp: Function;
    checkFile: Function;
    openPhotoPopUp: Function;
    closeCurrentModal: Function;
    openCrProfile: Function;
    openErrorModal: () => any;
    openAccountLimitAlertPopup: Function;
    openAssociateTeamProjectPopup: Function;
    openFolderOperationsPopup: Function;
    openSharePopup: Function;
    openToggleTeamFreezePopup: Function;
    openTooltipPopup: Function;
    openSplashScreen: Function;
    openMemberProfile: Function;
    getProfile: Function;
    openDiscussionPopupOnLinkClick: (event) => void;

    static $inject = ["$rootScope", "CacheService", "$uibModal", "$q", "ApiAdapterService", "UtilityService","$state"];
    ConfirmOwnershipModal: (request: any, popupType: any) => angular.IPromise<unknown>;
    OpenFormerTeamAlertPopUp: (formerSubjects: any, formerTeamNotification: any) => angular.IPromise<unknown>;

    constructor(
        $rootScope,
        CacheService,
        private $uibModal: angular.ui.bootstrap.IModalService,
        private $q: angular.IQService,
        private ApiAdapterService: JavaApiAdapterService,
        UtilityService,
        private $state
    ) {
        this.openInformationModal = (confirmationMessage, error?, type?, infoMessage?, showUpper?, mdlClass?) => {
            this.confirmationMessage = confirmationMessage;
            this.error = error;

            var modalClass = null;
            if (!!showUpper) {
                modalClass = 'info-modal';
            }
            if (mdlClass) {
                modalClass = mdlClass;
            }

            if (!!type) {
                this.type = type;
            } else {
                this.type = 'information';
            }
            if (!!infoMessage) {
                this.infoMessage = infoMessage;
            }
            var deferred = $q.defer();
            this.currentOpenModal = $uibModal.open({
                templateUrl: 'app/common/popup/template/popup.html',
                controller: 'PopUpController as popUpVm',
                backdrop: 'static',
                keyboard: false,
                windowClass: modalClass,
            });
            this.currentOpenModal.result.then(
                function (s) {
                    if (!!s && !!s.defaultClose) {
                        //do nothing
                    } else {
                        deferred.resolve('test');
                    }
                },
                function () {
                    deferred.reject('testFaile');
                })
            return deferred.promise;
        };

        this.closeCurrentModal = () => {
            if (!!this.currentOpenModal) {
                if (typeof this.currentOpenModal.close !== "undefined") {
                    this.currentOpenModal.close({ "defaultClose": "true" });
                }
            }
        }

        this.openConfirmationModal = (confirmationMessage?, yesOption?, noOption?, type?, infoMessage?, showUpper?, removeCross?) => {
            this.yesOption = null;
            this.noOption = null;
            this.type = 'confirmation';
            if (!!yesOption)
                this.yesOption = yesOption;
            if (!!noOption)
                this.noOption = noOption;
            if (!!type) {
                this.type = type;
            }
            if (!!confirmationMessage)
                this.confirmationMessage = confirmationMessage;
            else
                this.confirmationMessage = 'Are you sure you want to delete ?';
            if (!!infoMessage)
                this.infoMessage = "<div>" + infoMessage + "</div>";
            else
                this.infoMessage = "default";

            if (!!removeCross)
                this.removeCross = removeCross;

            var modalClass = null;
            if (!!showUpper) {
                modalClass = 'confirm-modal';
            }

            var deferred = $q.defer();
            this.currentOpenModal = $uibModal.open({
                templateUrl: 'app/common/popup/template/popup.html',
                controller: 'PopUpController as popUpVm',
                backdrop: 'static',
                keyboard: false,
                windowClass: modalClass,
            });
            this.currentOpenModal.result.then(
                function (s) {
                    if (!!s && !!s.message) {
                        deferred.resolve(s);
                    } else if (s && s.action == Util.DO_IT_LATER) {
                        deferred.resolve(s);
                    } else if (!!s && !!s.defaultClose) {
                        //do nothing
                    } else {
                        deferred.resolve('success');
                    }
                },
                function () {
                    deferred.reject('error');
                })
            return deferred.promise;
        };

        this.openErrorModal = () => {
            $uibModal.open({
                templateUrl: 'app/gauth/gauth.error.html'
            });
        };

        this.OpenTransferOwnershipModal = function (teamMember, subject, transferAgain, requestObj, isExit, cancelAndTransferAgain, title?, message?) {
            var deferred = $q.defer();

            $uibModal.open({
                templateUrl: 'app/common/popup/transferTeamOwner/transferTeamOwner.html',
                controller: 'TransferTeamOwnerController as transferTeamOwnerVm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    teamMember: () => teamMember || null,
                    subject: () => subject || null,
                    transferAgain: () => transferAgain || false,
                    requestObj: () => requestObj || null,
                    isExit: () => isExit || false,
                    cancelAndTransferAgain: () => cancelAndTransferAgain || false,
                    title: () => title || null,
                    displayMessage: () => message || null
                }
            }).result.then((s) => {
                deferred.resolve(s);
            }, (e) => {
                deferred.reject(e);
            });

            return deferred.promise;
        };

        this.ConfirmOwnershipModal = function (request, popupType) {
            var deferred = $q.defer();
            var modalClass = null;
            if (popupType == 'alreadyTransferred') {
                modalClass = 'ownership-modal';
            }
            $uibModal.open({
                templateUrl: 'app/common/popup/ownershipConfirmation/ownershipConfirmation.html',
                controller: 'OwnershipConfirmationController as ownershipConfirmationVm',
                backdrop: 'static',
                keyboard: false,
                windowClass: modalClass,
                resolve: {
                    request: () => request,
                    popupType: () => popupType
                }
            }).result.then((s) => {
                deferred.resolve(s);
            }, (e) => {
                deferred.reject(e);
            });

            return deferred.promise;
        };

        // open send invite popup from care team action
        this.OpenInvitePopup = (subject: Subject, user: any, popupMessage: string, title?: string, inviteCancelInfo?: string, isQuickPopUp?: boolean) => {
            var deferred = $q.defer();

            $uibModal.open({
                templateUrl: 'app/common/popup/sendInvite/sendInvite.html',
                controller: 'SendInviteController as sendInviteVm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    subject: () => subject,
                    user: () => user,
                    popupMessage: () => popupMessage,
                    title: () => title || null,
                    inviteCancelInfo: () => inviteCancelInfo || null,
                    isQuickPopUp: () => isQuickPopUp || false
                }
            }).result.then((s) => {
                deferred.resolve(s);
            }, (e) => {
                deferred.reject(e);
            });

            return deferred.promise;
        };

        this.openDiscussionPopupOnLinkClick = (event) => {
            const link = event.target.closest("a");
            if (link && link.origin.includes("ecarevault.com")) {
                event.preventDefault();
                $uibModal.open({
                    templateUrl: 'app/common/itemCard/components/showDiscussionsLink/showDiscussionsLink.html',
                    controller: 'ShowDiscussionsLinkController as showDiscussionsLinkVm',
                    backdrop: 'static',
                    keyboard: false
                }).result.then((action) => {
                    if (action === "same") {
                        window.location.href = link.href;
                    } else if (action === "new") {
                        window.open(link.href, "_blank", "noopener");
                    }
                }, (e) => {
                });
            }
        };

        // modal for share document
        this.openSignupJoinTeam = function () {
            var deferred = $q.defer();

            $uibModal.open({
                templateUrl: 'app/common/popup/signup/signup.joinTeam.html',
                controller: 'SignupJoinTeamController',
                windowClass: 'wizard-modal',
                backdrop: 'static',
                keyboard: false,
            }).result.then((s) => {
                deferred.resolve(s);
            }, (e) => {
                deferred.reject(e);
            });

            return deferred.promise;
        };

        this.openTeamRolePopUp = (data) => {
            var deferred = $q.defer();
            this.data = data;

            $uibModal.open({
                templateUrl: 'app/common/popup/teamrole/popup.teamrole.html',
                controller: 'TeamRolePopUpController as teamRolePopUpVm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    Subject: data.subject
                }
            }).result.then(
                function (s) {
                    deferred.resolve(s);
                },
                function (e) {
                    deferred.reject(e);
                })
            return deferred.promise;
        };

        this.openPrivacyPopUp = (data) => {
            var deferred = $q.defer();
            this.data = data;

            $uibModal.open({
                templateUrl: 'app/common/popup/privacy/privacy.html',
                controller: 'PrivacyPopUpController as privacyPopUpVm',
                backdrop: 'static',
                keyboard: false,
                windowClass: 'privacy-popup',
            }).result.then(
                function (s) {
                    deferred.resolve(s);
                },
                function (e) {
                    deferred.reject(e);
                })
            return deferred.promise;
        };

        this.openCoveredEntity = () => {
            var deferred = $q.defer();

            $uibModal.open({
                templateUrl: 'app/common/popup/template/covered-entity.html',
                controller: 'PopUpController as popUpVm',
            }).result.then(
                function (s) {
                    deferred.resolve(s);
                },
                function (e) {
                    deferred.reject(e);
                })
            return deferred.promise;
        }

        this.checkFile = (file) => {
            if (file) {
                if ((file.size || file.size === 0) && file.size < 4194304 && file.$ngfHeight < 4096) {
                    return true;
                }
            }
            return false;
        }

        this.openPhotoPopUp = ($file) => {
            var deferred = $q.defer();

            if (this.checkFile($file) == false) {
                deferred.reject(`Invalid Image File. <br> Image size should not be more than 5MB,
            and resolution should not be more than 4096x4096 px.`);
            } else {
                var photoPath = $file;

                var photoModal = $uibModal.open({
                    templateUrl: 'app/common/popup/addphoto/addphoto.html',
                    controller: 'PhotoCropController as photoCropVm',
                    backdrop: 'static',
                    keyboard: false,
                    resolve: {
                        'photoPath': $file
                    }
                }).result
                    .then(
                        (s) => {
                            var photo64 = s.croppedImage;
                            deferred.resolve({
                                photo: photo64,
                                filetype: $file.filetype || $file.type,
                                filename: $file.name
                            });
                        },
                        (e) => {
                            deferred.reject(e);
                        }
                    );
            }

            return deferred.promise;
        }

        this.openToggleTeamFreezePopup = (team) => {
            var deferred = $q.defer();
            this.$uibModal.open({
                templateUrl: 'app/common/popup/toggleTeamFreeze/toggleTeamFreeze.html',
                controller: 'ToggleTeamFreezeController as tfVm',
                backdrop: 'static',
                keyboard: false,
                windowClass: 'tf-popup',
                resolve: {
                    team: () => team
                }
            }).result.then((obj) => {
                deferred.resolve(obj);
            }).catch(() => {
                deferred.reject();
            });
            return deferred.promise;
        }

        this.openSplashScreen = (messages: any) => {
            const deferred = $q.defer();

            $uibModal.open({
                animation: true,
                templateUrl: 'app/common/popup/splashScreen/splashScreen.html',
                controller: 'SplashScreenController as ssVm',
                backdrop: 'static',
                keyboard: false,
                windowClass: 'splash-screen',
                resolve: {
                    messages: () => messages
                }
            }).result.then(
                () => {
                    deferred.resolve();
                },
                (error: any) => {
                    console.error('Splash screen dismissed:', error);
                    deferred.resolve();
                }
            );

            return deferred.promise;
        };

        this.OpenFormerTeamAlertPopUp = (formerSubjects, formerTeamNotification) => {
            var deferred = $q.defer();

            $uibModal.open({
                templateUrl: 'app/common/popup/formerTeamAlert/formerTeamAlert.html',
                controller: 'FormerTeamAlertController as formerTeamAlertVm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    FormerSubjects: formerSubjects,
                    formerTeamNotification: formerTeamNotification
                }
            }).result.then(
                function (s) {
                    deferred.resolve(s);
                },
                function (e) {
                    deferred.reject(e);
                })
            return deferred.promise;
        };

        this.openCrProfile = (subject: Subject): void => {
            $uibModal.open({
                templateUrl: 'app/common/popup/crProfilePopup/crProfilePopup.html',
                controller: 'CrProfilePopupController',
                controllerAs: 'crProfilePopupVm',
                windowClass: 'cr-profile-modal',
                resolve: {
                    subject: () => subject
                }
            }).result.then(
                function (s) {
                    //do something
                },
                function (e) {
                    console.log(e);
                }
            );
        }

        this.openAccountLimitAlertPopup = (title: string, message: string) => {
            var deferred = $q.defer();

            ApiAdapterService.getPlans(true).then(
                (s) => {
                    $uibModal.open({
                        templateUrl: 'app/common/popup/accountLimitAlert/accountLimitAlert.html',
                        controller: 'AccountLimitAlertController as accountLimitAlertVm',
                        backdrop: 'static',
                        keyboard: false,
                        resolve: {
                            title: () => title,
                            message: () => message,
                            plans: () => s || null
                        }
                    }).result.then(
                        function (s) {
                            deferred.resolve(s);
                        },
                        function (e) {
                            deferred.reject(e);
                        });
                },
                e => {
                    console.log('error while fetching all subscription plans');
                    console.log(e);
                }
            );

            return deferred.promise;
        };


        this.openAssociateTeamProjectPopup = (project: any) => {
            var deferred = $q.defer();

            $uibModal.open({
                templateUrl: 'app/common/popup/associateTeamsToProject/associateTeamsToProject.html',
                controller: 'AssociateTeamsToProjectController as associateTeamsVm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    project: () => project || null
                }
            }).result.then(
                function (s) {
                    deferred.resolve(s);
                },
                function (e) {
                    deferred.reject(e);
                })
            return deferred.promise;
        }

        this.openSharePopup = (item, itemId, eligibleUsers, sharedUsers, dispAs, newItem, icon, iconBgColor, addTMOption, msgs) => {
            var deferred = $q.defer();

            $uibModal.open({
                templateUrl: 'app/common/share/components/sharePopup/generalSharePopup.html',
                controller: 'GeneralSharePopupController as gShareVm',
                backdrop: 'static',
                keyboard: false,
                windowClass: 'share-container',
                resolve: {
                    eligibleUsers: eligibleUsers,
                    sharedUsers: () => sharedUsers,
                    item: () => item || null,
                    itemId: () => itemId || null,
                    displayAs: () => dispAs || null,
                    headerIcon: () => icon,
                    newItem: () => newItem,
                    iconBgColor: () => iconBgColor,
                    addTMOption: () => addTMOption,
                    msgs: () => msgs
                }
            }).result.then(s => deferred.resolve(s), e => deferred.reject(e));

            return deferred.promise;
        };

        this.openTooltipPopup = (template, controller, styleClass) => {
            var deferred = $q.defer();

            $uibModal.open({
                templateUrl: template,
                controller: controller,
                backdrop: 'static',
                keyboard: false,
                windowClass: styleClass
            }).result.then(s => deferred.resolve(s), e => deferred.reject(e));

            return deferred.promise;
        };

        this.openFolderOperationsPopup = (operation, postType, folder) => {
            var deferred = this.$q.defer();
            this.$uibModal.open({
                templateUrl: 'app/common/itemBoard/components/folderOperationsPopup/folderOperationsPopup.html',
                controller: 'FolderOperationsPopupController',
                controllerAs: 'fldrOpVm',
                windowClass: 'folder-operations-modal',
                backdrop: 'static',
                resolve: {
                    operation: () => operation,
                    postType: () => postType,
                    currentFolder: () => folder
                }
            }).result.then(
                success => { deferred.resolve(success); },
                error => { deferred.reject(error); }
            );
            return deferred.promise;
        }

        this.openMemberProfile = (parent, mode?, subject?, addInst?, showInvite?) => {
            $rootScope.mainShowLoader = "Fetching Profile ..."

            var deferred = $q.defer();
            var memberProfileInstance = $uibModal.open({
                templateUrl: 'app/common/popup/memberProfile/memberProfile.html',
                backdrop: 'static',
                keyboard: false,
                controller: 'MemberProfileController as myMemberVm',
                resolve: {
                    memberProfile: parent.userId ? this.getProfile(parent, subject) : parent,
                    mode: () => mode || null,
                    subject: () => subject || null,
                    addInst: () => addInst || null,  //  Used to tell to close after save or let the popup stay open
                    showInvite: () => showInvite == false ? showInvite : true
                }
            }).result.then(
                success => { deferred.resolve(success); },
                error => { deferred.reject(error); }
            );

            return deferred.promise;
        }

        this.getProfile = (parent, subject) => {
            var deferred = $q.defer();

            if (!parent.teamRoleId) {
                ApiAdapterService.getUserByEmail(parent.providerIdentity, subject.subjectId).then(
                    (s) => {
                        parent.deserialize(s);
                        deferred.resolve(parent);
                    }
                );
            } else {
                deferred.resolve(parent);
            }

            return deferred.promise;
        }

    }
}


angular.module('eCareVault.common.popUp')
    .service('PopUpService', PopUpService);
